export default __webpack_public_path__ + "static/media/all-team.cfa96a74.jpg";